import React, { useState } from 'react'
import { SquareButton } from '../../../styles/ButtonStyles'
import { Button, Drawer, Stack, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import { ArrowBack, PieChart } from '@mui/icons-material'
import { t } from 'i18next'
import CostPieChartContent from './CostPieChartContent'

type CostPieChartSidebarProps = {
  resize: boolean
  date: string
}

const CostPieChartSidebar = ({ resize, date }: CostPieChartSidebarProps) => {
  const [open, setOpen] = useState<boolean>(false)
  const theme = useTheme()
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))

  const handleOpen = () => setOpen(true)

  const handleClose = () => setOpen(false)

  return (
    <>
      {resize ? (
        <Tooltip title={t('page.costSummary.summary')} placement="bottom">
          <SquareButton onClick={handleOpen} color="secondary">
            <PieChart />
          </SquareButton>
        </Tooltip>
      ) : (
        <Button variant={'contained'} startIcon={<PieChart />} color="secondary" size="medium" onClick={handleOpen}>
          {t('page.costSummary.summary')}
        </Button>
      )}

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { bgcolor: 'background.main', overflowX: 'hidden' }, elevation: 0 }}
      >
        <Stack px={isDownSm ? 3 : 6} pt={3} pb={3} width={isDownSm ? '350px' : '570px'}>
          <Button
            onClick={handleClose}
            variant="text"
            color="secondary"
            startIcon={<ArrowBack />}
            size="small"
            sx={{ position: 'absolute', ml: -3 }}
          >
            {t('components.infoSidebar.return')}
          </Button>
          <CostPieChartContent date={date} />
        </Stack>
      </Drawer>
    </>
  )
}

export default CostPieChartSidebar
